import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import baustein from "baustein";
import overlayMixin from "web/script/components/mixins/overlay-mixin";
export default baustein.register("editing-overlay", {
  mixins: [overlayMixin],
  defaultOptions: {
    overlaySize: "large",
    contentEditUrl: undefined
  },

  /**
   * Submit event handler
   * @param {object} event The event object
   */
  onOverlayCloseIntent: function onOverlayCloseIntent() {
    this.close();
  },

  /**
   * Get the overlay content
   */
  getOverlayContent: function getOverlayContent() {
    return Promise.resolve("\n            <iframe\n                sandbox=\"allow-same-origin allow-scripts allow-forms\"\n                width=\"100%\" height=\"450px\"\n                src=\"".concat(this.options.contentEditUrl, "\"\n            ></iframe>\n        "));
  }
});